import OneTimeOpenOption from './configuration/OneTimeOpenOption'
import StayOrLeaveOption from './configuration/StayOrLeaveOption'
import RentalConfigurationJson from './interfaces/RentalConfigurationJson'

export default class RentalConfiguration {
  oneTimeOpen: OneTimeOpenOption
  stayOrLeave: StayOrLeaveOption
  encourageSymbolCodeSetup: boolean

  constructor(
    oneTimeOpen: OneTimeOpenOption,
    stayOrLeave: StayOrLeaveOption,
    encourageSymbolCodeSetup: boolean,
  ) {
    this.oneTimeOpen = oneTimeOpen
    this.stayOrLeave = stayOrLeave
    this.encourageSymbolCodeSetup = encourageSymbolCodeSetup
  }

  isEncourageSymbolCodeSetup() {
    return this.encourageSymbolCodeSetup
  }

  static fromJson(data: RentalConfigurationJson) {
    return new this(
      OneTimeOpenOption.fromJson(data.oneTimeOpen),
      StayOrLeaveOption.fromJson(data.stayOrLeave),
      data.encourageSymbolCodeSetup,
    )
  }
}
